import React from 'react';

import FlowForm from 'app/common/components/FlowForm';
import FormaticConfig from 'app/developer-v3/FormaticConfig';
import formFields from 'app/developer-v3/pages/actions/ActionApi/formFieldsLegacy';
import { setReadOnly } from 'app/developer-v3/utils';
import type { ActionType } from 'app/developer-v3/types';

type Props = {
  onChange: (value: {}) => void;
  isDisabled: boolean;
  type: ActionType;
  value: {};
};

const ConfigLegacy = (props: Props) => {
  const parsedFields = setReadOnly(formFields[props.type], props.isDisabled);

  return (
    <FlowForm
      config={FormaticConfig}
      fields={parsedFields}
      onChange={props.onChange}
      value={props.value}
    />
  );
};

export default ConfigLegacy;
